import React from 'react'

import { TitleSelect, CarWrapperMobile, ImageMobile, ButtonSecondary, ItemCar, ItemCarMobile, SelectedWrapper } from './styles'

import { Link } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { ButtonPrimary } from '../../../../../components/Buttons/style'
import { experiences } from '../../../../../constants'
import { TitlePage } from '../Characteristics/styles'
import { navigate } from 'gatsby'
import styled from 'styled-components'

const WrapperCarInfoMobile = styled.div`
  text-align: left;

  h5 {
    font-size: 15px;
    color: black;
    font-weight: 300;
    margin: 0;
    padding: 0;
  }

  p {
    font-size: 15px;
    color: black;
    font-weight: 300;
    margin: 0;
    margin-top: 3px;
    margin-bottom: 3px;
    padding: 0;
    line-height: 1.5rem;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const NoWrapper = styled.div`
  width: 100%;
  max-width: 700px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-radius: 3px;
  background-color: #ffffff;
  margin-top: 10px;
`

export const WrapperLink = styled.div`
  a {
    text-align: left !important;
  }
`

const CarSelect = ({ model, envs, location, modelPage, hasWrapper, isMenu, car }) => {
  const breakpoints = useBreakpoint()
  const url = location?.href || ''
  const experience = experiences[envs.SITE]

  const goToExperience = () => {
    navigate(`${experience[model?.experiece_class]}&callback=${url}`)
  }

  if (!hasWrapper) {
    return (
      <NoWrapper>
        <ImageMobile src={`https://www.ford360guide.com${model.model_image && model.model_image.url}`} />
        <InfoWrapper>
          <WrapperCarInfoMobile>
            <h5>{model[envs.VERSIONS.slice(0, -1)].Version_Full_Name}</h5>
            <p>{model.Model_Name}</p>
          </WrapperCarInfoMobile>
          {!isMenu && (
            <ButtonSecondary style={{ marginBottom: 0, padding: 0, textAlign: 'left' }}>
              {/* <Link to="https://staging.guia360ford.com.br/">{ modelPage.select_another_vehicle_text}</Link> */}
              <WrapperLink>
                <a
                  onClick={() => {
                    if (window.gtag && car) {
                      window.gtag('event', 'select-another-vehicle', {
                        event_category: `${car[envs.CATEGORY].category_slug.toLowerCase()}-${car.car_name.toLowerCase()}`,
                        event_label: window.location.href
                      })
                    }

                    navigate('/')
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <span style={{ fontSize: '12px', textAlign: 'left' }}>{modelPage.select_another_vehicle_text}</span>
                </a>
              </WrapperLink>
              <span className="fds-icon" style={{ marginLeft: '10px', display: 'block', transform: 'rotate(180deg)' }}>
                <span className="fds-font--ford-icons__chevron-filled-left-path1-with-hover"></span>
                <span className="fds-font--ford-icons__chevron-filled-left-path2"></span>
              </span>
            </ButtonSecondary>
          )}
        </InfoWrapper>
      </NoWrapper>
    )
  }

  return (
    <ItemCarMobile breakpoints={breakpoints}>
      <CarWrapperMobile>
        <ImageMobile src={`https://www.ford360guide.com${model.model_image && model.model_image.url}`} />
        <InfoWrapper>
          <WrapperCarInfoMobile>
            <h5>{model[envs.VERSIONS.slice(0, -1)].Version_Full_Name}</h5>
            <p>{model.Model_Name}</p>
          </WrapperCarInfoMobile>
          {model.has_expert && model.expert_link && model.expert_button_text && (
            <ButtonSecondary style={{ marginBottom: 0, padding: 0 }}>
              <a
                onClick={() => {
                  window.open(model.expert_link)
                  navigate('/')
                }}
                style={{ cursor: 'pointer' }}
              >
                <span style={{ fontSize: '12px' }}>{model.expert_button_text}</span>
              </a>
              <span className="fds-icon" style={{ marginLeft: '10px', display: 'block', transform: 'rotate(180deg)' }}>
                <span className="fds-font--ford-icons__chevron-filled-left-path1-with-hover"></span>
                <span className="fds-font--ford-icons__chevron-filled-left-path2"></span>
              </span>
            </ButtonSecondary>
          )}

          <ButtonSecondary style={{ marginBottom: 0, padding: 0 }}>
            {/* <Link to="https://staging.guia360ford.com.br/">{ modelPage.select_another_vehicle_text}</Link> */}
            <a
              onClick={() => {
                if (window.gtag && car) {
                  window.gtag('event', 'select-another-vehicle', {
                    event_category: `${car[envs.CATEGORY].category_slug.toLowerCase()}-${car.car_name.toLowerCase()}`,
                    event_label: window.location.href
                  })
                }
                navigate('/')
              }}
              style={{ cursor: 'pointer' }}
            >
              <span style={{ fontSize: '12px' }}>{modelPage.select_another_vehicle_text}</span>
            </a>
            <span className="fds-icon" style={{ marginLeft: '10px', display: 'block', transform: 'rotate(180deg)' }}>
              <span className="fds-font--ford-icons__chevron-filled-left-path1-with-hover"></span>
              <span className="fds-font--ford-icons__chevron-filled-left-path2"></span>
            </span>
          </ButtonSecondary>
        </InfoWrapper>
      </CarWrapperMobile>
    </ItemCarMobile>
  )
}

export default CarSelect
